import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
export let EIntegratorClientStatus;
(function (EIntegratorClientStatus) {
  EIntegratorClientStatus["Connected"] = "connected";
  EIntegratorClientStatus["Disconnected"] = "disconnected";
  EIntegratorClientStatus["NeedsHeartbeat"] = "needs-heartbeat";
})(EIntegratorClientStatus || (EIntegratorClientStatus = {}));
export let EIntegratorClientState;
(function (EIntegratorClientState) {
  EIntegratorClientState["Uninstalled"] = "uninstalled";
  EIntegratorClientState["Installed"] = "installed";
  EIntegratorClientState["Updating"] = "updating";
})(EIntegratorClientState || (EIntegratorClientState = {}));
export const fieldsIntegratorClient = _extends({}, fieldsIBaseModel, {
  enabled: {
    type: 'Boolean'
  },
  lastHeartbeat: {
    type: 'Date'
  },
  lastRecycleAttempt: {
    type: 'Date'
  },
  name: {
    type: 'Text'
  },
  secret: {
    type: 'Text'
  },
  state: {
    type: 'Option',
    values: EIntegratorClientState
  },
  status: {
    type: 'Option',
    values: EIntegratorClientStatus
  },
  version: {
    type: 'Text'
  }
});